import { Component, OnInit } from '@angular/core';
import { ThemeModeService } from './_metronic/layout/core/theme-mode.service';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // Default change detection on purpose: with OnPush here the whole tree is only checked when
  // something marks a view dirty, so a page doing `subscribe(res => this.x = res)` (filter
  // dropdowns fed from the API) never repainted unless an `async` pipe or a click happened to
  // run first. Metronic ships OnPush on the root; this app does not need it.
})
export class AppComponent implements OnInit {
  constructor(private readonly themeMode: ThemeModeService) {}

  ngOnInit() {}
}
